module.exports = __webpack_public_path__ + "img/empty.72d36f85.png";